(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      const initializerVersion = 'swatch-layout-v3';
      if (!root || root.dataset.zcCardsInitialized === initializerVersion) return;
      root.dataset.zcCardsInitialized = initializerVersion;

      const mobileQuery = window.matchMedia('(max-width: 749px)');

      const restoreNativeSwatches = (picker) => {
        const overflowList = picker.querySelector('overflow-list');
        const mobileList = picker.querySelector('.zc-mobile-swatches');
        if (!overflowList || !mobileList) return;

        const nativeMoreItem = overflowList.querySelector('li[slot="more"]');
        mobileList.querySelectorAll('.variant-option__swatch').forEach((item) => {
          item.removeAttribute('slot');
          item.classList.remove('zc-mobile-swatches__extra');
          overflowList.insertBefore(item, nativeMoreItem);
        });
        mobileList.remove();
      };

      const retainSelectedSwatch = (list, limit) => {
        const items = Array.from(list.querySelectorAll('.variant-option__swatch'));
        const visible = new Set(items.slice(0, limit));
        const selected = items.find((item) => item.querySelector('input:checked'));
        if (selected && !visible.has(selected)) {
          visible.delete(items[limit - 1]);
          visible.add(selected);
        }
        items.forEach((item) => {
          item.classList.toggle('zc-mobile-swatches__extra', !visible.has(item));
        });
      };

      const configureSwatches = () => {
        root.querySelectorAll('.zc-product-list__item swatches-variant-picker-component').forEach((picker) => {
          const overflowList = picker.querySelector('overflow-list');
          if (!overflowList) return;
          if (!mobileQuery.matches) {
            restoreNativeSwatches(picker);
            return;
          }

          let mobileList = picker.querySelector('.zc-mobile-swatches');
          const nativeSwatches = Array.from(overflowList.querySelectorAll('.variant-option__swatch'));
          const existingSwatches = mobileList
            ? Array.from(mobileList.querySelectorAll('.variant-option__swatch'))
            : [];
          const total = nativeSwatches.length + existingSwatches.length;
          const hitSize = 44;
          const gap = 2;
          const availableWidth = picker.clientWidth;
          const fitsAll = total * hitSize + Math.max(0, total - 1) * gap <= availableWidth;
          const visibleLimit = fitsAll
            ? total
            : Math.max(1, Math.min(3, Math.floor((availableWidth - hitSize) / (hitSize + gap))));

          if (mobileList && Number(mobileList.dataset.visibleLimit) !== visibleLimit) {
            restoreNativeSwatches(picker);
            mobileList = null;
          }

          if (mobileList) {
            retainSelectedSwatch(mobileList, visibleLimit);
            return;
          }

          const swatches = Array.from(overflowList.querySelectorAll('.variant-option__swatch'));
          if (swatches.length === 0) return;

          mobileList = document.createElement('ul');
          mobileList.className = 'zc-mobile-swatches';
          mobileList.setAttribute('role', 'list');
          mobileList.dataset.visibleLimit = String(visibleLimit);

          swatches.forEach((item) => {
            item.removeAttribute('slot');
            mobileList.appendChild(item);
          });
          retainSelectedSwatch(mobileList, visibleLimit);

          if (swatches.length > visibleLimit) {
            const hiddenCount = swatches.length - visibleLimit;
            const toggleItem = document.createElement('li');
            toggleItem.className = 'zc-mobile-swatches__toggle-item';

            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'zc-mobile-swatches__toggle';
            toggle.textContent = `+${hiddenCount}`;
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', `Show ${hiddenCount} more variants`);
            toggle.addEventListener('click', () => {
              const expanded = mobileList.classList.toggle('is-expanded');
              if (!expanded) retainSelectedSwatch(mobileList, visibleLimit);
              toggle.textContent = expanded ? '−' : `+${hiddenCount}`;
              toggle.setAttribute('aria-expanded', String(expanded));
              toggle.setAttribute('aria-label', expanded ? 'Show fewer variants' : `Show ${hiddenCount} more variants`);
            });

            toggleItem.appendChild(toggle);
            mobileList.appendChild(toggleItem);
          }

          overflowList.insertAdjacentElement('afterend', mobileList);
        });
      };

      const refreshCards = () => {
        configureSwatches();
      };

      let resizeFrame;
      const scheduleRefresh = () => {
        cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => {
          refreshCards();
        });
      };

      scheduleRefresh();
      mobileQuery.addEventListener('change', scheduleRefresh);
      root.addEventListener('change', scheduleRefresh);

      window.addEventListener('resize', () => {
        scheduleRefresh();
      });

      const observer = new MutationObserver(scheduleRefresh);
      observer.observe(root, { childList: true, subtree: true });

      if (document.fonts?.ready) {
        document.fonts.ready.then(scheduleRefresh);
      }

      root.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', scheduleRefresh, { once: true });
      });
    };

    document.querySelectorAll('.zc-product-list-match').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('.zc-product-list-match'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zc-product-image-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initTabs = (root) => {
      if (!root || root.dataset.zcTabsReady === 'true') return;
      root.dataset.zcTabsReady = 'true';

      const tabs = [...root.querySelectorAll('[data-zc-tab]')];
      const panels = [...root.querySelectorAll('[data-zc-panel]')];

      const activate = (id, focusTab = false) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.zcTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (active && focusTab) tab.focus();
        });

        panels.forEach((panel) => {
          const active = panel.dataset.zcPanel === id;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab.dataset.zcTab));
        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          activate(tabs[next].dataset.zcTab, true);
        });
      });

      root.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[data-zc-panel]');
        if (panel) activate(panel.dataset.zcPanel);
      });
    };

    const initAll = () => document.querySelectorAll('.zc-image-tabs').forEach(initTabs);
    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zingcrater-best-sellers-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root) => {
      if (!root || root.dataset.zcInitialized === 'true') return;
      root.dataset.zcInitialized = 'true';

      const tabs = Array.from(root.querySelectorAll('[data-zc-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-zc-panel]'));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      let activeIndex = 0;

      const syncFeatureHeights = () => {
        root.querySelectorAll('[data-zc-panel]').forEach((panel) => {
          if (panel.hidden) return;

          const feature = panel.querySelector('.zc-best-sellers__feature');
          const productItems = Array.from(panel.querySelectorAll('.zc-best-sellers__product'));
          const productCards = productItems
            .map((item) => item.querySelector('product-card'))
            .filter(Boolean);
          if (!feature || productCards.length === 0) return;

          if (mobileQuery.matches) {
            productItems.forEach((item) => item.style.removeProperty('height'));
            const firstProductHeight = Math.ceil(productCards[0].getBoundingClientRect().height);
            if (firstProductHeight > 0) feature.style.height = `${firstProductHeight}px`;
            return;
          }

          const tallestProductHeight = Math.ceil(
            Math.max(...productCards.map((card) => Math.max(card.scrollHeight, card.getBoundingClientRect().height)))
          );
          if (tallestProductHeight <= 0) return;

          productItems.forEach((item) => {
            item.style.height = `${tallestProductHeight}px`;
          });
          feature.style.height = `${tallestProductHeight}px`;
        });
      };

      const resetMeasuredHeights = () => {
        root.querySelectorAll('.zc-best-sellers__product, .zc-best-sellers__feature').forEach((item) => {
          item.style.removeProperty('height');
        });
      };

      const configureMobileSwatches = () => {
        root.querySelectorAll('swatches-variant-picker-component').forEach((picker) => {
          const overflowList = picker.querySelector('overflow-list');
          if (!overflowList) return;

          let mobileList = picker.querySelector('.zc-mobile-swatches');
          const totalSwatches = picker.querySelectorAll('.variant-option__swatch').length;
          const visibleLimit = mobileQuery.matches ? Math.min(3, totalSwatches) : totalSwatches;

          if (mobileList && Number(mobileList.dataset.visibleLimit) !== visibleLimit) {
            const nativeMoreItem = overflowList.querySelector('li[slot="more"]');
            mobileList.querySelectorAll('.variant-option__swatch').forEach((item) => {
              item.removeAttribute('slot');
              item.classList.remove('zc-mobile-swatches__extra');
              overflowList.insertBefore(item, nativeMoreItem);
            });
            mobileList.remove();
            mobileList = null;
          }

          if (mobileList) return;

          const swatches = Array.from(overflowList.querySelectorAll('.variant-option__swatch'));
          if (swatches.length === 0) return;

          mobileList = document.createElement('ul');
          mobileList.className = 'zc-mobile-swatches';
          mobileList.setAttribute('role', 'list');
          mobileList.dataset.visibleLimit = String(visibleLimit);

          swatches.forEach((item, index) => {
            item.removeAttribute('slot');
            item.classList.toggle('zc-mobile-swatches__extra', index >= visibleLimit);
            mobileList.appendChild(item);
          });

          if (swatches.length > visibleLimit) {
            const hiddenCount = swatches.length - visibleLimit;
            const toggleItem = document.createElement('li');
            toggleItem.className = 'zc-mobile-swatches__toggle-item';

            const toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'zc-mobile-swatches__toggle';
            toggle.textContent = `+${hiddenCount}`;
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', `Show ${hiddenCount} more variants`);

            toggle.addEventListener('click', () => {
              const expanded = mobileList.classList.toggle('is-expanded');
              toggle.textContent = expanded ? '−' : `+${hiddenCount}`;
              toggle.setAttribute('aria-expanded', String(expanded));
              toggle.setAttribute(
                'aria-label',
                expanded ? 'Show fewer variants' : `Show ${hiddenCount} more variants`
              );
            });

            toggleItem.appendChild(toggle);
            mobileList.appendChild(toggleItem);
          }

          overflowList.insertAdjacentElement('afterend', mobileList);
        });
      };

      configureMobileSwatches();
      mobileQuery.addEventListener('change', configureMobileSwatches);

      let swatchResizeFrame;
      window.addEventListener('resize', () => {
        window.cancelAnimationFrame(swatchResizeFrame);
        resetMeasuredHeights();
        swatchResizeFrame = window.requestAnimationFrame(() => {
          configureMobileSwatches();
          window.requestAnimationFrame(syncFeatureHeights);
        });
      });

      const cardResizeObserver = new ResizeObserver(() => {
        window.requestAnimationFrame(syncFeatureHeights);
      });
      root.querySelectorAll('.zc-best-sellers__product product-card').forEach((card) => {
        cardResizeObserver.observe(card);
      });
      window.requestAnimationFrame(syncFeatureHeights);

      const swatchObserver = new MutationObserver(() => {
        window.requestAnimationFrame(configureMobileSwatches);
      });
      swatchObserver.observe(root, { childList: true, subtree: true });

      const activate = (index, moveFocus = false) => {
        if (!tabs[index] || !panels[index] || index === activeIndex) return;

        tabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });

        const outgoing = panels[activeIndex];
        const incoming = panels[index];
        incoming.hidden = false;
        incoming.classList.add('is-active', 'is-visible');

        if (reducedMotion) {
          incoming.classList.remove('is-visible');
          outgoing.classList.remove('is-active');
          outgoing.hidden = true;
        } else {
          outgoing.classList.add('is-leaving');
          window.requestAnimationFrame(() => incoming.classList.remove('is-visible'));
          window.setTimeout(() => {
            outgoing.classList.remove('is-active', 'is-leaving');
            outgoing.hidden = true;
          }, 380);
        }

        activeIndex = index;
        window.requestAnimationFrame(syncFeatureHeights);
        if (moveFocus) tabs[index].focus();
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));
        tab.addEventListener('keydown', (event) => {
          let nextIndex = index;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;

          event.preventDefault();
          activate(nextIndex, true);
        });
      });
    };

    document.querySelectorAll('[data-zc-best-sellers]').forEach(initialize);
    document.addEventListener('shopify:section:load', (event) => {
      initialize(event.target.querySelector('[data-zc-best-sellers]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zingcrater-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'zc_recently_viewed_v2';
    const legacyStorageKey = 'zc_recently_viewed_v1';
    const responseCache = new Map();

    const getHandleFromLegacyProduct = (product) => {
      if (typeof product?.handle === 'string' && product.handle) return product.handle;
      if (typeof product?.url !== 'string' || !product.url) return '';

      try {
        const url = new URL(product.url, window.location.origin);
        const parts = url.pathname.split('/').filter(Boolean);
        const productIndex = parts.indexOf('products');
        return productIndex >= 0 ? parts[productIndex + 1] || '' : '';
      } catch (error) {
        return '';
      }
    };

    const readHistory = () => {
      try {
        const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const handles = Array.isArray(stored)
          ? stored.filter((handle) => typeof handle === 'string' && handle)
          : [];

        if (handles.length) return handles;

        const legacy = JSON.parse(localStorage.getItem(legacyStorageKey) || '[]');
        if (!Array.isArray(legacy)) return [];

        return legacy
          .map(getHandleFromLegacyProduct)
          .filter(Boolean)
          .filter((handle, index, allHandles) => allHandles.indexOf(handle) === index);
      } catch (error) {
        return [];
      }
    };

    const writeHistory = (handles) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(handles));
      } catch (error) {
        console.warn('Recently viewed products could not be saved.', error);
      }
    };

    const getCurrentProduct = (root) => {
      const data = root.querySelector('[data-zc-current-product]');
      if (!data) return null;

      try {
        return JSON.parse(data.textContent || '{}');
      } catch (error) {
        return null;
      }
    };

    const fetchCard = async (root, handle) => {
      const cacheKey = handle;

      if (responseCache.has(cacheKey)) {
        return responseCache.get(cacheKey).cloneNode(true);
      }

      const shopRoot = window.Shopify?.routes?.root || '/';
      const baseRoot = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;
      const requestUrl = `${baseRoot}products/${encodeURIComponent(handle)}`;

      const response = await fetch(requestUrl, {
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      });

      if (!response.ok) return null;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector('[data-zc-recent-card-source]');

      if (!(source instanceof HTMLTemplateElement)) return null;

      const card = source.content.firstElementChild;
      if (!card) return null;

      responseCache.set(cacheKey, card.cloneNode(true));
      return card.cloneNode(true);
    };

    const getScrollDistance = (root) => {
      const grid = root.querySelector('[data-zc-recent-grid]');
      const scroller = root.querySelector('[data-zc-recent-scroller]');
      const firstCard = grid?.firstElementChild;

      if (!firstCard || !scroller) return scroller?.clientWidth || 0;

      const styles = getComputedStyle(grid);
      const gap = parseFloat(styles.columnGap || styles.gap || '0');
      return firstCard.getBoundingClientRect().width + gap;
    };

    const updateArrowStates = (root) => {
      const scroller = root.querySelector('[data-zc-recent-scroller]');
      const controls = root.querySelector('[data-zc-recent-controls]');
      const previous = root.querySelector('[data-zc-recent-previous]');
      const next = root.querySelector('[data-zc-recent-next]');

      if (!scroller || !controls || !previous || !next) return;

      const maximum = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const overflows = maximum > 4;

      controls.hidden = !overflows;
      previous.disabled = !overflows || scroller.scrollLeft <= 4;
      next.disabled = !overflows || scroller.scrollLeft >= maximum - 4;
    };

    const showDesignPreview = (root) => {
      if (root.dataset.designMode !== 'true') return false;

      const source = root.querySelector('[data-zc-recent-card-source]');
      const grid = root.querySelector('[data-zc-recent-grid]');
      if (!grid) return false;

      if (!(source instanceof HTMLTemplateElement)) {
        const placeholder = document.createElement('div');
        placeholder.className = 'zc-recently-viewed__editor-placeholder';
        placeholder.textContent =
          'Recently viewed product cards will appear here after products have been visited.';
        grid.replaceChildren(placeholder);
        root.hidden = false;
        return true;
      }

      grid.append(source.content.cloneNode(true));
      root.hidden = false;
      return true;
    };

    const showEmptyState = (root, grid) => {
      if (!grid || root.dataset.productPage === 'true') return;

      if (root.dataset.showEmptyState !== 'true') {
        root.hidden = true;
        return;
      }

      const empty = document.createElement('div');
      empty.className = 'zc-recently-viewed__empty';
      empty.textContent =
        root.dataset.emptyMessage || 'Your recently viewed products will appear here.';
      grid.replaceChildren(empty);
      root.hidden = false;
    };

    const applyProductTitleBlockSettings = (root) => {
      const source = root.querySelector('[data-zc-recent-card-source]');
      if (!(source instanceof HTMLTemplateElement)) return;

      const cardSettings = source.content.querySelector('[data-zc-card-settings]');
      if (cardSettings instanceof HTMLElement) {
        const allowedTitlePositions = ['flex-start', 'center', 'flex-end'];
        const titleVertical = allowedTitlePositions.includes(cardSettings.dataset.titleVertical)
          ? cardSettings.dataset.titleVertical
          : 'flex-start';
        const mobileTitleVertical = allowedTitlePositions.includes(cardSettings.dataset.mobileTitleVertical)
          ? cardSettings.dataset.mobileTitleVertical
          : 'flex-start';

        const getSwatchMargins = (position) => {
          if (position === 'top') return ['0', 'auto'];
          if (position === 'center') return ['auto', 'auto'];
          return ['auto', '0'];
        };

        const [swatchesStart, swatchesEnd] = getSwatchMargins(cardSettings.dataset.swatchesVertical);
        const [mobileSwatchesStart, mobileSwatchesEnd] = getSwatchMargins(
          cardSettings.dataset.mobileSwatchesVertical
        );

        root.style.setProperty('--zc-recent-title-vertical', titleVertical);
        root.style.setProperty('--zc-recent-title-vertical-mobile', mobileTitleVertical);
        root.style.setProperty('--zc-recent-swatches-margin-start', swatchesStart);
        root.style.setProperty('--zc-recent-swatches-margin-end', swatchesEnd);
        root.style.setProperty('--zc-recent-swatches-margin-start-mobile', mobileSwatchesStart);
        root.style.setProperty('--zc-recent-swatches-margin-end-mobile', mobileSwatchesEnd);
      }

      const titleEditor = source.content.querySelector('[id^="ProductTitleEditor-"]');
      if (!(titleEditor instanceof HTMLElement) || !titleEditor.id) return;

      const escapedId = titleEditor.id.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const rules = [...source.content.querySelectorAll('style')]
        .flatMap((style) => [...(style.textContent || '').matchAll(/([^{}]+)\{([^{}]*)\}/g)])
        .map((match) => ({ selectors: match[1], declarations: match[2] }));

      const baseRule = rules.find(({ selectors }) =>
        new RegExp(`#${escapedId}\\s+p(?:\\s|,|$)`).test(selectors) &&
        !selectors.includes(':hover') &&
        !selectors.includes(':focus-visible')
      );
      const hoverRules = rules.filter(({ selectors }) =>
        new RegExp(`#${escapedId}\\s*>\\s*a:hover\\s+p`).test(selectors)
      );

      const readColor = (declarations = '') =>
        declarations.match(/(?:^|;)\s*color\s*:\s*([^;!]+)/i)?.[1]?.trim() || '';

      const titleColor = readColor(baseRule?.declarations);
      const hoverColor = hoverRules.map(({ declarations }) => readColor(declarations)).find(Boolean) || '';
      const hoverDeclarations = hoverRules.map(({ declarations }) => declarations).join(';');

      let hoverEffect = hoverRules.length ? 'color' : 'none';
      const hasLift = /transform\s*:\s*translateY/i.test(hoverDeclarations);
      const hasUnderline = /text-decoration\s*:\s*underline/i.test(hoverDeclarations);

      if (hasLift && hasUnderline) hoverEffect = 'lift_underline';
      else if (hasLift) hoverEffect = 'lift';
      else if (hasUnderline) hoverEffect = 'underline';

      if (titleColor && titleColor !== 'inherit') {
        root.style.setProperty('--zc-recent-product-title', titleColor);
      }
      if (hoverColor && hoverColor !== 'inherit') {
        root.style.setProperty('--zc-recent-title-hover', hoverColor);
      }

      root.dataset.zcTitleHoverEffect = hoverEffect;
    };

    const initialize = async (root) => {
      if (!root || root.dataset.zcInitialized === 'true') return;
      root.dataset.zcInitialized = 'true';

      const grid = root.querySelector('[data-zc-recent-grid]');
      const scroller = root.querySelector('[data-zc-recent-scroller]');
      const previous = root.querySelector('[data-zc-recent-previous]');
      const next = root.querySelector('[data-zc-recent-next]');
      const clear = root.querySelector('[data-zc-recent-clear]');
      const current = getCurrentProduct(root);
      const visibleLimit = Math.max(1, Number(root.dataset.productsToShow) || 8);
      const historyLimit = Math.max(visibleLimit, Number(root.dataset.historyLimit) || 16);

      applyProductTitleBlockSettings(root);

      if (current?.handle) {
        const existingHistory = readHistory();
        const updatedHistory = [
          current.handle,
          ...existingHistory.filter((handle) => handle !== current.handle)
        ].slice(0, historyLimit);

        writeHistory(updatedHistory);
        root.hidden = true;
        return;
      }

      if (!grid || !scroller) {
        showDesignPreview(root);
        return;
      }

      const existingHistory = readHistory();
      const handlesToRender = existingHistory
        .slice(0, visibleLimit);

      previous?.addEventListener('click', () => {
        scroller.scrollBy({ left: -getScrollDistance(root), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        scroller.scrollBy({ left: getScrollDistance(root), behavior: 'smooth' });
      });

      scroller.addEventListener('scroll', () => updateArrowStates(root), { passive: true });
      window.addEventListener('resize', () => updateArrowStates(root), { passive: true });

      clear?.addEventListener('click', () => {
        writeHistory([]);
        try {
          localStorage.removeItem(legacyStorageKey);
        } catch (error) {
          console.warn('Legacy recently viewed products could not be cleared.', error);
        }

        grid.replaceChildren();
        root.hidden = false;
        showEmptyState(root, grid);
      });

      if (!handlesToRender.length) {
        if (!showDesignPreview(root)) showEmptyState(root, grid);
        return;
      }

      root.hidden = false;
      grid.innerHTML = Array.from(
        { length: handlesToRender.length },
        () => '<div class="zc-recently-viewed__loading" aria-hidden="true"></div>'
      ).join('');

      const cards = await Promise.all(
        handlesToRender.map((handle) => fetchCard(root, handle).catch(() => null))
      );

      grid.replaceChildren(...cards.filter(Boolean));

      if (!grid.children.length) {
        showEmptyState(root, grid);
        return;
      }

      requestAnimationFrame(() => updateArrowStates(root));
      document.fonts?.ready?.then(() => updateArrowStates(root));
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-zc-recently-viewed]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
